import { Controller } from "@hotwired/stimulus"

// M44. Each source has its own fields, so changing what a report reads from
// has to reload the form: the column tick-boxes, the group-by list and the
// filter fields all come from the server's registry, and guessing them in the
// browser would be a second copy of the one list that is allowed to exist.
export default class extends Controller {
  sourceChanged (event) {
    const url = new URL(window.location.href)
    url.searchParams.set("source_key", event.target.value)
    window.location.assign(url.toString())
  }
}
